document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('product-info .jdgm-widget')){
      document.querySelector('product-info .jdgm-widget').addEventListener('click', () => {
        document.querySelector('#reviews_accordion details').open = true;
      })
    }

    if (document.querySelector('.jdgm-write-rev-link')){
      document.querySelector('.jdgm-write-rev-link').addEventListener('click', (event) => {
        replaceInputWithButton('.jdgm-submit-rev')
        event.preventDefault();
        if (window.innerWidth > 990 ) {
          
          if (parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) >= 850){
            document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '0px';
          }
          else if (parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) >= 600)
          {
            document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '1000px';
          }
          else if (isNaN(parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop)) || parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) === 0){
            document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '1000px';
          } 
        }
        else if(window.innerWidth >= 750 && window.innerWidth < 990 ){
          document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '1050px';
        }
        else{
          if (isNaN(parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop)) || parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) >= 500) {
            if (parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) > 900) {
              document.querySelector('.jdgm--done-setup-widget').style.setProperty('padding-top', '0', 'important');
            } else {
              document.querySelector('.jdgm--done-setup-widget').style.setProperty('padding-top', '950px', 'important');
            }
          } else {
            if (parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) === 0) {
              document.querySelector('.jdgm--done-setup-widget').style.setProperty('padding-top', '950px', 'important');
            } else {
              document.querySelector('.jdgm--done-setup-widget').style.setProperty('padding-top', '0', 'important');
            }
          }
        }
      })

    }
      setTimeout(() => {
        if (document.querySelector('.jdgm-ask-question-btn')) {
          document.querySelector('.jdgm-ask-question-btn').addEventListener('click', (event) => {
            replaceInputWithButton('.jdgm-submit-question')
            event.preventDefault();
            
            if (window.innerWidth > 990) {
              if (parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) === 520){
                document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '0px';
              }
              else if (parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) >= 850)
              {
                document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '600px';
              }
              else if (isNaN(parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop)) || parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) === 0){
                document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '600px';
              } else {
                if (parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) >= 600) {
                  document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '0px';
                } else {
                  document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '600px';
                }
              }
            } else if (window.innerWidth >= 750 && window.innerWidth < 990) {
              document.querySelector('.jdgm--done-setup-widget').style.paddingTop = '1050px';
            } else {
              if (isNaN(parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop)) || parseInt(document.querySelector('.jdgm--done-setup-widget').style.paddingTop) >= 950) {
                document.querySelector('.jdgm--done-setup-widget').style.setProperty('padding-top', '550px', 'important');
              } else {
                document.querySelector('.jdgm--done-setup-widget').style.setProperty('padding-top', '0', 'important');
              }
            }
          });
        }
      }, 2000);                              
      
})

  function replaceInputWithButton(selector) {
    var inputElement = document.querySelector(selector);
    var buttonElement = document.createElement('button');
    
    Array.from(inputElement.attributes).forEach(attr => {
        buttonElement.setAttribute(attr.name, attr.value);
    });
    
    buttonElement.type = 'submit';
    buttonElement.textContent = inputElement.value;
   
    inputElement.parentNode.replaceChild(buttonElement, inputElement);
  }